// extracted by mini-css-extract-plugin
export default {"arrowIcon":"G3TVh","rotate":"UM57n"};